import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EmailRequest } from '../entities/email-request';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private api: ApiService) { }

  sendEmail(emailRequest: EmailRequest): Observable<string> {
    return this.api.postForm(emailRequest.mapToFormData(), 'email/form-data');
  }
}
